export default __webpack_public_path__ + "static/media/instagram.21047137.svg";